import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M360-140.001q-91.666 0-155.832-64.167Q140.001-268.334 140.001-360v-240q0-91.666 64.167-155.832Q268.334-819.999 360-819.999h240q91.666 0 155.832 64.167Q819.999-691.666 819.999-600v240q0 91.666-64.167 155.832Q691.666-140.001 600-140.001H360zm80-193.846L666.153-560 624-602.153l-184 184-88-88L309.847-464 440-333.847z"
      ></path>
    </svg>
  );
}

export default Icon;
